import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { adChackValve,chackValveDetailTitle } from "../../../constants";


const AddValveChackDetail = ( ) =>{
    const navigate = useNavigate();
    const [chackData, setChackData] = useState<any>([]);

    useEffect(()=>{
        const fetchChackData = async ()=>{              
            try{
                const response = await ApiService.axiosApi(`/chack`,{
                    method: 'GET',
                    params:{
                         pageNumber:0,
                         pageSize:0
                    }
                });
                if(response.success){
                    setChackData(response.data.data);
                }
            }catch(error:any){
            toast.error(error.message || "Failed to fetch Chack Data");
        }   }
        fetchChackData();
    },[]);  

    const handleValveDetail = async (data: any)=>{

        try{
            const response = await ApiService.axiosApi('/chackvalvedetail',{
                method : 'POST',
                 params:{
                     Id:data.chackId
                 }
            })
            if(response.success){
                toast.success(response.message || "Chack Valve Detail Added Successfully");
                navigate(-1);
            }else{
                toast.error(response.message || "Unable to add Chack Valve Detail");
                console.log(response.message || response.data)
            }
        }catch(error:any){
            toast.error(error.message || "Unable to add Chack Valve Detail");
        }
    }

    return(
        
        <Add
            title = {adChackValve}
            parentTitle={chackValveDetailTitle}
            onSubmit={handleValveDetail}
            fields={[

        
                {
                    name:"Chack",
                    label:"Chack",
                    isDropdown:true,
                    dropdownData:chackData,
                    dropdownLabel:"chackName",
                    idFieldName:"chackId"
    
                }
            ]}
        />
    )

}

export default AddValveChackDetail;